module.exports = __webpack_public_path__ + "static/0055-2e7644360a0b8721dbeaba714f25715d.png";